import React from "react";
import { Modal, Button, Icon } from "antd";

const ModalEndConference = ({ visible, onCancel, endConferenceForAll, endConference }) => {
    return (
        <Modal
            visible={visible}
            width="450px"
            className="modal-encerrar-stepmeet"
            footer={[
                <Button key="cancel" className="btn-cancelar" onClick={onCancel}>
                    Cancelar
                </Button>,
                <Button key="all" className="btn-para-todos" onClick={endConferenceForAll}>
                    Para todos
                </Button>,
                <Button key="me" className="btn-para-mim" onClick={endConference}>
                    Para mim
                </Button>
            ]}
        >
            <Icon type="question-circle" className="icon-modal-encerrer-stepmeet" />
            <p className="texto-modal-encerrar-stepmeet">Encerrar Stepmeet</p>
        </Modal>
    );
};

export default ModalEndConference;
